import React, {useEffect, useState} from "react";
import {Form, Row, Col, FloatingLabel, Button, Modal} from "react-bootstrap";
import axios from "axios";
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import GLOBALVAR from "../../constants";
import LoadingSpinner from "../../components/misc/LoadingSpinner";

function EditApplicant({applicantdb, updateParentApplicant}) {
    const [civilStatus, setCivilStatus] = useState("");
    const [isMarried, setIsMarried] = useState(false);
    const [birthday, setBirthday] = useState(null); // State to manage birthday
    const [showModal, setShowModal] = useState(false);
    const [modalHeader, setModalHeader] = useState(null);
    const [modalBody, setModalBody] = useState(null);
    const [showSpinner, setShowSpinner] = useState(false);
    const [applicant, setApplicant] = useState(applicantdb);

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);
    const [errMessages, setErrMessages] = useState(false);

    const handleCivilStatusChange = (e) => {
        setCivilStatus(e.target.value);
        setIsMarried(e.target.value === "Married");
    };

    const handleBirthdayChange = (date) => {
        setBirthday(date);
        const formattedDate = format(date, 'MM/dd/yyyy'); 
        handleChange({ target: { name: "birthday", value: formattedDate } });
    };

    const [formData, setFormData] = useState({
        lastName: applicant?applicant.lastName:'',
        firstName: applicant?applicant.firstName:'',
        middleName: applicant?applicant.middleName:'',
        mothersMaidenName: applicant?applicant.mothersMaidenName:'',
        street: applicant?applicant.street:'',
        barangay: applicant?applicant.barangay:'',
        municipality: applicant?applicant.municipality:'',
        province: applicant?applicant.province:'',
        zipCode: applicant?applicant.zipCode:'',
        birthday: applicant?format(applicant.birthday, 'MM/dd/yyyy'):'',
        gender: applicant?applicant.gender:'',
        civilStatus: applicant?applicant.civilStatus:'',
        marriedTo: applicant?applicant.marriedTo:'',
        telephoneNo: applicant?applicant.telephoneNo:'',
        mobileNo1: applicant?applicant.mobileNo1:'',
        mobileNo2: applicant?applicant.mobileNo2:'',
        emailAddress: applicant?applicant.emailAddress:'',
        sssOrGsis: applicant?applicant.sssOrGsis:'',
        passport: applicant?applicant.passport:'',
        employerDetails: applicant?applicant.employerDetails:'',
        employerAddress: applicant?applicant.employerAddress:'',
        employerContactNumber: applicant?applicant.employerContactNumber:'',
        employerLocation: applicant?applicant.employerLocation:''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setShowSpinner(true);

        try {
            const response = await axios.post(`${GLOBALVAR['SERVER_ROOT']}/api/applications/update/${applicant?applicant.id:null}`, formData);
            console.log(response.data.message); // Display the message returned from the server
            setModalHeader('Success');
            setModalBody(response.data.message);
            handleShow();
            setShowSpinner(false);
            
            setApplicant(response.data.application);
            updateParentApplicant(response.data.application);
        } catch (error) {
            console.error('Error submitting form:', error);
            setModalHeader('Validation Error');

            const errorsArray = error.response.data.error.split(',\n');
            const filteredErrors = errorsArray.filter(error => error.trim() !== '');
            setErrMessages(filteredErrors);
            handleShow();
            setShowSpinner(false);
        }
    };

    useEffect(() => {
        console.log(formData);
    },[formData]);

    return (
        <>
            {showSpinner && (<LoadingSpinner />)}
            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalHeader}</Modal.Title>
                </Modal.Header>
                {errMessages && (
                    <Modal.Body>
                    <ul>
                    {errMessages.map((error, index) => (
                        <li key={index}>{error.trim().replace('Validation error: ', '')}</li>
                    ))}
                    </ul>
                    </Modal.Body>
                )}
                {!errMessages && (
                    <Modal.Body>
                    {modalBody}
                    </Modal.Body>
                )}
            </Modal>
            <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
                <Col>
                <FloatingLabel controlId="floatingLastName" label={applicant?applicant.lastName:"Last Name"}>
                    <Form.Control type="text" name="lastName" placeholder="Last Name" onChange={handleChange} />
                </FloatingLabel>
                </Col>
                <Col>
                <FloatingLabel controlId="floatingFirstName" label={applicant?applicant.firstName:"First Name"}>
                    <Form.Control type="text" name="firstName" placeholder="First Name" onChange={handleChange} />
                </FloatingLabel>
                </Col>
                <Col>
                <FloatingLabel controlId="floatingMiddleName" label={applicant?applicant.middleName:"Middle Name"}>
                    <Form.Control type="text" name="middleName" placeholder="Middle Name" onChange={handleChange} />
                </FloatingLabel>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                <FloatingLabel controlId="floatingMothersMaidenName" label={applicant?applicant.mothersMaidenName:"Mother's Maiden Name"}>
                    <Form.Control type="text" name="mothersMaidenName" placeholder="Mother's Maiden Name" onChange={handleChange} />
                </FloatingLabel>
                </Col>
            </Row>
            <hr className="my-4"></hr>
            <Row className="mb-3">
                <Col>
                <FloatingLabel controlId="floatingStreet" label={applicant?applicant.street:"House No. / Street"}>
                    <Form.Control type="text" name="street" placeholder="House No. / Street" onChange={handleChange} />
                </FloatingLabel>
                </Col>
                <Col>
                <FloatingLabel controlId="floatingBarangay" label={applicant?applicant.barangay:"Barangay"}>
                    <Form.Control type="text" name="barangay" placeholder="Barangay" onChange={handleChange} />
                </FloatingLabel>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                <FloatingLabel controlId="floatingMunicipality" label={applicant?applicant.municipality:"Municipality/City"}>
                    <Form.Control type="text" name="municipality" placeholder="Municipality/City" onChange={handleChange} />
                </FloatingLabel>
                </Col>
                <Col>
                <FloatingLabel controlId="floatingProvince" label={applicant?applicant.province:"Province"}>
                    <Form.Control type="text" name="province" placeholder="Province" onChange={handleChange} />
                </FloatingLabel>
                </Col>
                <Col>
                <FloatingLabel controlId="floatingZipCode" label={applicant?applicant.zipCode:"Zip Code"}>
                    <Form.Control type="text" name="zipCode" placeholder="Zip Code" onChange={handleChange} />
                </FloatingLabel>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                {birthday ? (
                    <DatePicker
                    className="form-control"
                    selected={birthday} // Set the selected date
                    onChange={(e) => {
                        handleBirthdayChange(e);
                    }} // Handle date change
                    dateFormat="MM/dd/yyyy" // Date format
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    maxDate={new Date()} // Max date is today
                    name="birthday"
                
                    />
                ) : (
                    <FloatingLabel controlId="floatingBirthday" label={applicant?format(applicant.birthday, 'MM/dd/yyyy'):"Birthday"}>
                    <DatePicker
                        className="form-control"
                        selected={birthday} // Set the selected date
                        onChange={(e) => {
                            handleBirthdayChange(e);
                        }} // Handle date change
                        dateFormat="MM/dd/yyyy" // Date format
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        maxDate={new Date()} // Max date is today
                        name="birthday"
                    
                        />
                    </FloatingLabel>
                )}
                </Col>
                <Col>
                <FloatingLabel controlId="floatingGender" label={applicant?applicant.gender:"Gender"}>
                    <Form.Select defaultValue="Select Gender" name="gender" onChange={handleChange}>
                    <option>Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    </Form.Select>
                </FloatingLabel>
                </Col>
                <Col>
                <FloatingLabel controlId="floatingCivilStatus" label={applicant?applicant.civilStatus:"Civil Status"}>
                    <Form.Select value={civilStatus} name="civilStatus" onChange={(e)=>{handleCivilStatusChange(e);handleChange(e);}}>
                    <option>Select Civil Status</option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                    <option value="Widow">Widow</option>
                    <option value="Separated">Separated</option>
                    <option value="Annulled">Annulled</option>
                    </Form.Select>
                </FloatingLabel>
                </Col>
            </Row>
            {isMarried && (
                <Row className="mb-3">
                <Col>
                    <FloatingLabel controlId="floatingMarriedTo" label={applicant?applicant.marriedTo:"Married To"}>
                    <Form.Control type="text" placeholder="Married To" onChange={handleChange} name="marriedTo" />
                    </FloatingLabel>
                </Col>
                <Col>
                    <FloatingLabel controlId="floatingTelephoneNo" label={applicant?applicant.telephoneNo:"Telephone No."}>
                    <Form.Control type="text" placeholder="Telephone No." onChange={handleChange} name="telephoneNo" />
                    </FloatingLabel>
                </Col>
                </Row>
            )}
            <Row className="mb-3">
                <Col>
                <FloatingLabel controlId="floatingMobileNo1" label={applicant?applicant.mobileNo1:"Mobile No. 1"}>
                    <Form.Control type="text" placeholder="Mobile No. 1" onChange={handleChange} name="mobileNo1"/>
                </FloatingLabel>
                </Col>
                <Col>
                <FloatingLabel controlId="floatingMobileNo2" label={applicant?applicant.mobileNo2:"Mobile No. 2"}>
                    <Form.Control type="text" placeholder="Mobile No. 2" onChange={handleChange} name="mobileNo2" />
                </FloatingLabel>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                <FloatingLabel controlId="floatingEmailAddress" label={applicant?applicant.emailAddress:"E-Mail Address"}>
                    <Form.Control type="email" placeholder="E-Mail Address" onChange={handleChange} name="emailAddress" />
                </FloatingLabel>
                </Col>
            </Row>
            <hr className="my-4"></hr>
            <Row className="mb-3">
                <Col>
                <FloatingLabel controlId="floatingSSSOrGSIS" label={applicant?applicant.sssOrGsis:"SSS/GSIS #"}>
                    <Form.Control type="text" placeholder="SSS/GSIS #" onChange={handleChange} name="sssOrGsis" />
                </FloatingLabel>
                </Col>
                <Col>
                <FloatingLabel controlId="floatingPassport" label={applicant?applicant.passport:"Passport #"}>
                    <Form.Control type="text" placeholder="Passport #" onChange={handleChange} name="passport" />
                </FloatingLabel>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                <FloatingLabel controlId="floatingEmployerDetails" label={applicant?applicant.employerDetails:"Employer Details"}>
                    <Form.Control type="text" placeholder="Employer Details" onChange={handleChange} name="employerDetails" />
                </FloatingLabel>
                </Col>
                <Col>
                <FloatingLabel controlId="floatingEmployerAddress" label={applicant?applicant.employerAddress:"Employer Address"}>
                    <Form.Control type="text" placeholder="Employer Address" onChange={handleChange} name="employerAddress" />
                </FloatingLabel>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                <FloatingLabel controlId="floatingEmployerContactNumber" label={applicant?applicant.employerContactNumber:"Employer Contact Number"}>
                    <Form.Control type="text" placeholder="Employer Contact Number" onChange={handleChange} name="employerContactNumber" />
                </FloatingLabel>
                </Col>
                <Col>
                <FloatingLabel controlId="floatingEmployerLocation" label={applicant?applicant.employerLocation:"Employer Location"}>
                    <Form.Control type="text" placeholder="Employer Location" onChange={handleChange} name="employerLocation" />
                </FloatingLabel>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <Button variant="primary" type="submit" className="submit-btn" id="submit-application">Update Details</Button>
                </Col>
            </Row>
            </Form>
        </>
    );
}

export default EditApplicant